module.exports = __webpack_public_path__ + "static/media/Starmus_long_video.99541786.mp4";